import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserProfile } from '../hooks/useUserProfile';
import { hasInvoicePipeline } from '../constants/productModule';

/** Redirects orgs on `sanctionsmodule` away from invoice-era routes (dashboard, invoices, upload). */
export default function RequireInvoiceModule({ children }) {
  const { user } = useAuth();
  const { loading, productModule } = useUserProfile(user);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-12 text-gray-500 text-sm">
        Loading…
      </div>
    );
  }

  if (!hasInvoicePipeline(productModule)) {
    return <Navigate to="/suppliers" replace />;
  }

  return children;
}
